exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* disable focus rings on react-virtualized's Grids */\n.FixedHeaderGrid__fixedHeaderGrid___3DzAH [tabindex] {\n  outline: none !important;\n}\n", ""]);

// exports
exports.locals = {
	"fixedHeaderGrid": "FixedHeaderGrid__fixedHeaderGrid___3DzAH"
};